import { CountryCode } from '../countries';

export const INTERNAL_INVOICING_REGIONS: readonly string[] = [
    CountryCode.unitedStates,
    CountryCode.australia,
    CountryCode.newZealand,
];

export const hasInternalInvoicing = (regionCode?: string | null): boolean =>
    !!regionCode && INTERNAL_INVOICING_REGIONS.includes(regionCode);
